import {
  GET_TECH_DOC_BEGIN,
  GET_TECH_DOC_FAILURE,
  RESET_TECH_DOC,
  GET_TECH_DOC_SUCCESS,
  GET_MODEL_LIST_SUCCESS,
  GET_CHECKLIST_SUCCESS,
} from '../constants/ActionTypes';
import { getPageContentReducerKey } from '../utils/utils';

const techDocReducer = (state = {}, action) => {
  const key = getPageContentReducerKey({
    pageName: action.pageName,
    model: action.model,
    pageOpt: action.pageOpt,
  });
  switch (action.type) {
    case GET_TECH_DOC_BEGIN:
      return { ...state, loading: true };
    case GET_MODEL_LIST_SUCCESS:
      return { ...state, [action.pageName]: action.payload, loading: false };
    case GET_TECH_DOC_SUCCESS:
      return { ...state, [key]: action.payload, loading: false };
    case GET_CHECKLIST_SUCCESS: {
      const { checklist, summary, checkedIds } = action.payload;
      // checklist.unshift({
      //   title: 'Introduction',
      //   content: summary,
      // });
      checklist.forEach(item => {
        item.done = checkedIds.includes(item.id) ? true : false;
      });
      return {
        ...state,
        [key]: { checklist, summary },
        loading: false,
      };
    }
    case GET_TECH_DOC_FAILURE:
      return { ...state, error: action.payload, loading: false };
    case RESET_TECH_DOC:
      return {};
    default:
      return state;
  }
};

export default techDocReducer;
